import { ErrorMessage } from 'formik';

const FieldError = ({ fieldName }) => (
  <ErrorMessage name={fieldName} component="p" className="text-red-600 font-bold" />
);

export { FieldError };
